import React, { useState } from 'react'
import ModalInc from '../../../../../shared-ui/ModalInc'
import ButtonInc from '../../../../../shared-ui/ButtonInc'
import { TextValidator, SelectValidator, ValidatorForm } from 'react-material-ui-form-validator';
import MenuItem from '@mui/material/MenuItem';
import AlertDialog from '../../../../../components/AlertDialog/index.es6';
import { CircularProgress } from '@mui/material';
import { useStyle } from "./Style";
import { Grid } from '@mui/material'

const AddDeviceDamageClaimExpense = (props) => {
  const classes = useStyle();

  const [expenseType, setExpenseType] = useState('')
  const [amountInCents, setAmountInCents] = useState('');


  const reset = () => {
    setAmountInCents('');
    setExpenseType('');
  }
  const handleClaimExpense = () => {
    const payload = {
      "benefit_type": expenseType,
      // "invoice_amount_in_cents": Number(invoice_amount_in_cents),
      "benefit_amount_in_cents": Math.floor(Number(amountInCents) * 100),
      "benefit_usage_count": 0,
      // "invoice_number": invoiceNumber,
      "external_unique_identifier": null,
      "claim_guid": props.claim.guid

    }
    props.handleClaimExpense(payload)
    console.log("Death payload", payload)
    reset()
  }
  const handleExpenseCreatedSuccessfully = () => {
    props.resetCreateExpenseSuccessAlert();
    props.toggleClaimExpenseDialog();
    window.location.reload();
  }
  const handleExpenseCreateError = () => {
    props.resetCreateExpenseErrorAlert();
  }



  const handleChange = (event) => {
    const { name, value } = event.target

    if (name === "amountInCents") {
      setAmountInCents(value)
    }
    if (name === "selectexpensetype") {
      setExpenseType(value);
    }
  }
  return (
    <>
      <AlertDialog
        custom
        show={props.showCreateExpenseProgressAlert}
        size="sm"
        style={{ marginTop: '0', top: '30vh' }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'cancel'}
        showTitle={false}
        confirmBtnCssClass
      >
        <CircularProgress />
        <h2> Creating Claim Expense...</h2>
      </AlertDialog>

      <AlertDialog
        success
        show={props.showCreateExpenseSuccessAlert}
        size="sm"
        title={'Claim expense created'}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => { handleExpenseCreatedSuccessfully() }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={true}
        cancelBtnText={'cancel'}
        confirmBtnCssClass
      >

      </AlertDialog>

      <AlertDialog
        show={props.showCreateExpenseErrorAlert}
        danger
        title={'Error creating claim expense'}
        onConfirm={() => handleExpenseCreateError()}
        confirmBtnText={'Try again'}
        confirmBtnCssClass
        showCancel={false}
        style={{ marginTop: '0', top: '30vh' }}
      >

        {props.CreateExpenseError ? props.CreateExpenseError.message : ''}
      </AlertDialog>
      <ModalInc
        modalTitle="Input  Details "
        subTitle="Fill the below fields to add details"
        open={props.openClaimExpenseDialog}
        onClose={props.toggleClaimExpenseDialog}
        fullWidth

      >
        <ValidatorForm onSubmit={() => handleClaimExpense()} >
          <Grid container spacing={2} className={classes.editClaimDialog}>
            <Grid item xs={12} sm={12} md={12}>
              <SelectValidator
                labelId="select-expense-type"
                id="select-expense-type"
                value={expenseType}
                name='selectexpensetype'
                type="text"
                label="Select  Type"
                onChange={handleChange}
                variant="outlined"
                validators={['required']}
                errorMessages={['Please select type']}
                style={{ width: "100%" }}
                sx={{
                  fontFamily: "Open Sans",
                  fontStyle: "normal",
                  fontWeight: 300,
                  fontSize: "12px",
                  lineHeight: "16px",
                  letterSpacing: "0.005em",
                  color: "#000000",
                }}
              >

                {
                  props.claim.benefits.map((benefit, index) => (
                    <MenuItem
                      key={index}
                      sx={{
                        fontFamily: "Open Sans",
                        fontStyle: "normal",
                        fontWeight: 300,
                        fontSize: "12px",
                        lineHeight: "16px",
                        letterSpacing: "0.005em",
                        color: "#000000",
                      }}
                      value={benefit.type}>{benefit.type}</MenuItem>
                  ))
                }

              </SelectValidator>
            </Grid>



            <Grid item xs={12} sm={12} md={12}>
              <TextValidator
                name='amountInCents'
                id="amountInCents"
                label="Amount Payable"
                type="number"
                value={amountInCents}
                onChange={handleChange}
                fullWidth
                variant="outlined"
                validators={['required']}
                errorMessages={['Please enter Amount']}
              />
            </Grid>

          </Grid>
          <Grid container spacing={2} >
            <Grid item xs={12} sm={6} md={6}>

            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={8} md={8}>
                  <ButtonInc
                    variant="contained"
                    color="primary"
                    size="large"
                    type='submit'
                    style={{ marginTop: "20px", float: "right" }}
                  >
                    Save details
                  </ButtonInc>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <ButtonInc
                    variant="contained"
                    color="primary"
                    size="large"
                    style={{ marginTop: "20px" }}
                    onClick={props.toggleClaimExpenseDialog}
                  >
                    Cancel
                  </ButtonInc>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </ValidatorForm>
      </ModalInc>

    </>
  )
}

export default AddDeviceDamageClaimExpense